var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountCameraSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,8l-5,0.0019531V5c0-1.6542969-1.3457031-3-3-3H11C9.3457031,2,8,3.3457031,8,5v3H3c-1.6542969,0-3,1.3457031-3,3v16 c0,1.6542969,1.3457031,3,3,3h26c1.6542969,0,3-1.3457031,3-3V11C32,9.3457031,30.6542969,8,29,8z M30,27 c0,0.5517578-0.4482422,1-1,1H3c-0.5517578,0-1-0.4482422-1-1V11c0-0.5517578,0.4482422-1,1-1h5c1.1025391,0,2-0.8974609,2-2V5 c0-0.5517578,0.4482422-1,1-1h10c0.5517578,0,1,0.4482422,1,1v3c0,1.1025391,0.8974609,2,2,2h5c0.5517578,0,1,0.4482422,1,1V27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,11c-3.859375,0-7,3.140625-7,7s3.140625,7,7,7s7-3.140625,7-7S19.859375,11,16,11z M16,23 c-2.7568359,0-5-2.2431641-5-5s2.2431641-5,5-5s5,2.2431641,5,5S18.7568359,23,16,23z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCameraSmall);
export default __webpack_public_path__ + "static/media/account-camera--small.ddc6fb9e82922f87e828534a2ae3e662.svg";
export { ForwardRef as ReactComponent };